export default "/assets/images/whitenoise-mode.422b88c6df48f692.mp4";